// One timestamp format for every compliance surface: "2026-08-20 18:09 UTC".
// Raw ISO strings with microseconds read as debug output, not a record.
export function fmtTs(iso) {
  if (!iso) return '—';
  const m = String(iso).match(/^(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2})/);
  return m ? `${m[1]} ${m[2]} UTC` : String(iso);
}

export function fmtDate(iso) {
  if (!iso) return '—';
  return String(iso).slice(0, 10);
}
